var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.754 11.739-1.735 4.788a.36.36 0 0 0 .454.454l4.788-1.735L17.346 5.162c.793-.794 1.003-2.193-.156-3.352-1.16-1.159-2.558-.95-3.352-.156L3.754 11.739Z",
    stroke: "#fff",
    strokeOpacity: 0.48,
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};
export { SvgEdit as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNzUzODMgMTEuNzM4NUwyLjAxOTA1IDE2LjUyNjhDMS45MjU0OCAxNi44MDc1IDIuMTkyNTIgMTcuMDc0NSAyLjQ3MzIxIDE2Ljk4MUw3LjI2MTUgMTUuMjQ2MkwxNy4zNDYgNS4xNjE2M0MxOC4xMzkyIDQuMzY4NDUgMTguMzQ4NSAyLjk2OTM0IDE3LjE4OTYgMS44MTA0QzE2LjAzMDcgMC42NTE0NTQgMTQuNjMxNiAwLjg2MDc4MyAxMy44Mzg0IDEuNjUzOTdMMy43NTM4MyAxMS43Mzg1WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLW9wYWNpdHk9IjAuNDgiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";